<template>
  <PartnersLayout>
    <template #header>
      <PartnersHeader
        title="내 추천 광고"
        subtitle="추천 현장 광고 신청 현황"
      />
    </template>

    <div class="px-4 lg:px-6 pb-6">
      <div class="max-w-6xl mx-auto">
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <!-- 왼쪽: 바로가기 -->
          <div class="lg:col-span-1 space-y-4">
            <!-- 바로가기 -->
            <div class="bg-white rounded-2xl border border-slate-200 p-5">
              <h3 class="font-semibold text-slate-800 mb-3">바로가기</h3>
              <div class="space-y-2">
                <router-link
                  to="/partners/recommend/purchase"
                  class="flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 transition group"
                >
                  <div class="w-9 h-9 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition">
                    <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
                    </svg>
                  </div>
                  <div class="flex-1">
                    <p class="text-sm font-medium text-slate-700">광고 신청</p>
                    <p class="text-xs text-slate-500">새 추천 광고 등록하기</p>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
                <router-link
                  to="/partners/ad/my"
                  class="flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 transition group"
                >
                  <div class="w-9 h-9 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition">
                    <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/>
                    </svg>
                  </div>
                  <div class="flex-1">
                    <p class="text-sm font-medium text-slate-700">내 캠페인</p>
                    <p class="text-xs text-slate-500">캠페인 목록 확인</p>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
                <router-link
                  to="/partners/leads/banner"
                  class="flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 transition group"
                >
                  <div class="w-9 h-9 bg-amber-100 rounded-lg flex items-center justify-center group-hover:bg-amber-200 transition">
                    <svg class="w-4 h-4 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                    </svg>
                  </div>
                  <div class="flex-1">
                    <p class="text-sm font-medium text-slate-700">광고 유입 콜</p>
                    <p class="text-xs text-slate-500">광고로 들어온 상담</p>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
              </div>
            </div>

            <!-- 안내 카드 -->
            <div class="bg-white rounded-2xl border border-slate-200 p-5">
              <div class="flex items-center gap-2 mb-3">
                <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                  <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <h3 class="font-semibold text-slate-800">광고 상태 안내</h3>
              </div>
              <ul class="text-sm text-slate-600 space-y-2">
                <li class="flex items-center gap-2">
                  <span class="w-2 h-2 bg-amber-400 rounded-full"></span>
                  <span><strong class="text-amber-600">승인 대기</strong> - 관리자 검토 중</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="w-2 h-2 bg-green-400 rounded-full"></span>
                  <span><strong class="text-green-600">승인됨</strong> - 노출 중</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="w-2 h-2 bg-red-400 rounded-full"></span>
                  <span><strong class="text-red-600">거절됨</strong> - 사유 확인</span>
                </li>
              </ul>
            </div>

            <!-- 노출 위치 안내 -->
            <div class="bg-blue-50 rounded-2xl border border-blue-100 p-5">
              <div class="flex items-center gap-2 mb-3">
                <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                  <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"/>
                  </svg>
                </div>
                <h3 class="font-semibold text-slate-800">노출 위치</h3>
              </div>
              <p class="text-sm text-slate-600">
                현장 상세 페이지 하단<br/>
                <strong class="text-blue-600">"이런 현장 어때요?"</strong> 섹션 첫 번째 슬롯
              </p>
            </div>
          </div>

          <!-- 오른쪽: 메인 콘텐츠 -->
          <div class="lg:col-span-2">
            <!-- 로딩 -->
            <div v-if="loading" class="bg-white rounded-2xl border border-slate-200 p-12 flex items-center justify-center">
              <div class="spinner"></div>
            </div>

            <!-- 빈 상태 -->
            <div v-else-if="recommendAds.length === 0" class="bg-white rounded-2xl border border-slate-200 p-12 text-center">
              <svg class="w-16 h-16 mx-auto text-slate-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"/>
              </svg>
              <h3 class="text-lg font-semibold text-slate-700 mb-2">신청한 추천 광고가 없습니다</h3>
              <p class="text-slate-500 mb-6">"이런 현장 어때요?" 섹션에 현장을 홍보해보세요!</p>
              <router-link
                to="/partners/recommend/purchase"
                class="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition"
              >
                광고 신청하기
              </router-link>
            </div>

            <!-- 광고 목록 -->
            <div v-else class="space-y-4">
              <div
                v-for="ad in recommendAds"
                :key="ad.id"
                class="bg-white rounded-2xl border border-slate-200 overflow-hidden"
              >
                <!-- 광고 미리보기 -->
                <div class="relative" style="height: 180px;">
                  <div
                    class="absolute inset-0"
                    :style="{ backgroundImage: `linear-gradient(105deg, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0) 100%), url('${ad.imageUrl}')`, backgroundSize: 'cover', backgroundPosition: 'center' }"
                  ></div>
                  <div class="relative h-full p-5 flex flex-col justify-between text-white">
                    <div class="px-2 py-1 text-xs font-bold rounded-md bg-blue-600/90 backdrop-blur-sm self-start">
                      AD
                    </div>
                    <div>
                      <h3 class="text-lg font-bold">{{ ad.propertyName }}</h3>
                      <p class="text-sm opacity-90 mt-1">{{ ad.title }}</p>
                    </div>
                  </div>
                  <!-- 상태 배지 -->
                  <div class="absolute top-3 right-3">
                    <span :class="[
                      'px-3 py-1 text-xs font-medium rounded-full',
                      getStatusClass(ad.status)
                    ]">
                      {{ getStatusLabel(ad.status) }}
                    </span>
                  </div>
                </div>

                <!-- 광고 정보 -->
                <div class="p-4">
                  <div class="grid grid-cols-2 gap-4 text-sm">
                    <div>
                      <p class="text-slate-400">현장</p>
                      <p class="font-medium text-slate-700">{{ ad.propertyName }}</p>
                    </div>
                    <div>
                      <p class="text-slate-400">캠페인 코드</p>
                      <p class="font-medium text-slate-700">{{ ad.campaignCode }}</p>
                    </div>
                    <div>
                      <p class="text-slate-400">노출 시간대</p>
                      <p class="font-medium text-slate-700">
                        {{ ad.timeSlot?.icon }} {{ ad.timeSlot?.label || '-' }}
                        <span v-if="ad.timeSlot" class="text-slate-500">({{ ad.timeSlot.start }}-{{ ad.timeSlot.end }})</span>
                      </p>
                    </div>
                    <div>
                      <p class="text-slate-400">기간</p>
                      <p class="font-medium text-slate-700">1주일</p>
                    </div>
                    <div>
                      <p class="text-slate-400">신청일</p>
                      <p class="font-medium text-slate-700">{{ formatDate(ad.createdAt) }}</p>
                    </div>
                    <div>
                      <p class="text-slate-400">상태</p>
                      <p :class="['font-medium', getStatusTextClass(ad.status)]">
                        {{ getStatusLabel(ad.status) }}
                      </p>
                    </div>
                  </div>

                  <!-- 통계 (승인된 경우) -->
                  <div v-if="ad.status === 'approved'" class="mt-4 p-3 bg-blue-50 rounded-xl">
                    <div class="grid grid-cols-3 gap-4 text-center">
                      <div>
                        <p class="text-2xl font-bold text-blue-600">{{ ad.impressions || 0 }}</p>
                        <p class="text-xs text-slate-500">노출</p>
                      </div>
                      <div>
                        <p class="text-2xl font-bold text-blue-600">{{ ad.clicks || 0 }}</p>
                        <p class="text-xs text-slate-500">클릭</p>
                      </div>
                      <div>
                        <p class="text-2xl font-bold text-blue-600">{{ getClickRate(ad) }}%</p>
                        <p class="text-xs text-slate-500">클릭률</p>
                      </div>
                    </div>
                  </div>

                  <!-- 거절 사유 -->
                  <div v-if="ad.status === 'rejected' && ad.rejectReason" class="mt-4 p-3 bg-red-50 rounded-xl">
                    <p class="text-sm text-red-600">
                      <strong>거절 사유:</strong> {{ ad.rejectReason }}
                    </p>
                  </div>

                  <!-- 삭제 버튼 (모든 상태에서 가능) -->
                  <div class="mt-4 pt-4 border-t border-slate-100">
                    <button
                      @click="handleCancel(ad)"
                      :disabled="cancelling === ad.id"
                      class="px-4 py-2 text-sm text-red-600 border border-red-200 rounded-lg hover:bg-red-50 transition disabled:opacity-50"
                    >
                      {{ cancelling === ad.id ? '삭제 중...' : (ad.status === 'pending' ? '신청 취소' : '삭제') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PartnersLayout>
</template>

<script>
import { ref, onMounted } from 'vue'
import PartnersLayout from '@/components/partners/common/PartnersLayout.vue'
import PartnersHeader from '@/components/partners/common/PartnersHeader.vue'
import { useAuth } from '@/composables/common/useAuth'
import { useRecommendAd } from '@/composables/partners/useRecommendAd'

export default {
  name: 'MyRecommendAdsView',
  components: {
    PartnersLayout,
    PartnersHeader
  },
  setup() {
    const { user } = useAuth()
    const { getMyRecommendAds, cancelRecommendAd } = useRecommendAd()

    const loading = ref(true)
    const recommendAds = ref([])
    const cancelling = ref(null)

    const loadRecommendAds = async () => {
      if (!user.value) return

      loading.value = true
      try {
        recommendAds.value = await getMyRecommendAds(user.value.uid)
      } catch (err) {
        console.error('추천 광고 로드 실패:', err)
      } finally {
        loading.value = false
      }
    }

    const getStatusLabel = (status) => {
      switch (status) {
        case 'pending': return '승인 대기'
        case 'approved': return '승인됨 (노출중)'
        case 'rejected': return '거절됨'
        default: return status
      }
    }

    const getStatusClass = (status) => {
      switch (status) {
        case 'pending': return 'bg-amber-100 text-amber-700'
        case 'approved': return 'bg-green-100 text-green-700'
        case 'rejected': return 'bg-red-100 text-red-600'
        default: return 'bg-slate-100 text-slate-600'
      }
    }

    const getStatusTextClass = (status) => {
      switch (status) {
        case 'pending': return 'text-amber-600'
        case 'approved': return 'text-green-600'
        case 'rejected': return 'text-red-600'
        default: return 'text-slate-600'
      }
    }

    const formatDate = (dateStr) => {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    }

    const getClickRate = (ad) => {
      if (!ad.impressions || ad.impressions === 0) return 0
      return ((ad.clicks || 0) / ad.impressions * 100).toFixed(1)
    }

    const handleCancel = async (ad) => {
      if (!confirm('추천 광고 신청을 취소하시겠습니까?')) return

      cancelling.value = ad.id

      try {
        await cancelRecommendAd(ad.id)
        alert('추천 광고 신청이 취소되었습니다.')
        await loadRecommendAds()
      } catch (err) {
        console.error('취소 실패:', err)
        alert('취소에 실패했습니다: ' + err.message)
      } finally {
        cancelling.value = null
      }
    }

    onMounted(() => {
      loadRecommendAds()
    })

    return {
      loading,
      recommendAds,
      cancelling,
      getStatusLabel,
      getStatusClass,
      getStatusTextClass,
      formatDate,
      getClickRate,
      handleCancel
    }
  }
}
</script>

<style scoped>
@reference "tailwindcss";

.spinner {
  @apply w-8 h-8 border-3 border-blue-600 border-t-transparent rounded-full animate-spin;
}
</style>
